import { ActionReducerMap } from '@ngrx/store';


import * as fromAuth from './reducers/login/auth.reducers';
import * as fromForgot from './reducers/login/forgot.reducers';
import * as fromPerfilInic from './reducers/AdmMapa/perfilIni.reducers';
import * as fromMapaBase from './reducers/AdmMapa/mapaBase.reducers';
import * as fromListaLayers from './reducers/AdmMapa/ListaLayers.reducers';
import * as fromModelosEjecutados from './reducers/AdmMapa/ModelosEjecutados.reducers';
import * as fromRedAgua from './reducers/AdmMapa/RedAgua/RedAgua.reducers';
import * as fromBusquedaNiss from './reducers/AdmMapa/BusquedaNiss.reducers';
import * as fromRangoMP from './reducers/Componentes/Modelos/RangoMP.reducers';
import * as fromMenuAction from './reducers/Componentes/menu.reducers';
import * as fromPDAction from './reducers/Componentes/panelDatos.reducers';
import * as fromFichaPDAction from './reducers/Componentes/fichaPD.reducers';
import * as fromOpcionDCAction from './reducers/AdmMapa/Cartografia/menuOpcDC.reducers';
import * as fromOpcionDMAction from './reducers/Componentes/Modelos/menuOpcDM.reducers';
import * as fromPMBaseAction from './reducers/Componentes/panelMB.reducers';
import * as fromPCToolsAction from './reducers/Componentes/panelCtools.reducers';
import * as fromdatosMPSAction from './reducers/Componentes/Modelos/datoMPS.reducers';
import * as fromGraficoSAction from './reducers/Componentes/Modelos/graficoSel.reducers';
import * as fromPOLAction from './reducers/Componentes/ordenlayer.reducers';
import * as fromResultAR from './reducers/AdmMapa/RedAgua/ResultRA.reducers';
import * as fromColor from './reducers/Componentes/color.reducers';
import * as fromPELAction from './reducers/Componentes/editorLayer.reducers';
import * as fromPEOUCAction from './reducers/Componentes/editorOuc.reducers';
import * as fromSGLAction from './reducers/Componentes/selectGLayer.reducers';
import * as fromOperCato from './reducers/AdmMapa/Cartografia/CapasOper.reducers';
import * as fromDCA from './reducers/AdmMapa/Cartografia/DatosCartoActivo.reducers';
import * as fromODS from './reducers/AdmMapa/Cartografia/OpcionSelect.reducers';
import * as fromOES from './reducers/AdmMapa/Cartografia/EjecucionSelect.reducers';
import * as fromRegUsr from './reducers/login/reguser.reducers';
// Administracion
import * as fromAdmCarto from './reducers/AdmSiicart/Cartografia/admCarto.reducers';
import * as fromAdmGrpCarto from './reducers/AdmSiicart/Cartografia/admGrpCarto.reducers';

import * as fromAdmModelos from './reducers/AdmSiicart/Modelos/admModelos.reducers';
import * as fromAdmGrpModelos from './reducers/AdmSiicart/Modelos/admGrpModelos.reducers';
import * as fromAdmDatosT from './reducers/AdmSiicart/Modelos/admDatosT.reducers';
import * as fromAdmCamposC from './reducers/AdmSiicart/Modelos/admCamposC.reducers';
import * as fromMainLoad from './reducers/shared/mainLoad.reducers';

import * as fromPerfiles from './reducers/AdmSiicart/Perfiles/admPerfil.reducers';
import * as fromUsuarios from './reducers/AdmSiicart/Usuarios/admUsuario.reducers';

import * as fromEmpresa from './reducers/AdmSiicart/Usuarios/admEmpresa.reducers';

import * as fromCatalogos from './reducers/shared/catalogo.reducers';
//
import * as fromSelectCP from './reducers/Componentes/CortarPoligonos/SelectView.reducers';
import * as fromCScene from './reducers/AdmMapa/Escenarios/ConfScene.reducer';
import * as fromScene from './reducers/AdmMapa/Escenarios/Escenarios.reducer';
import * as fromUserScene from './reducers/AdmMapa/Escenarios/UsuariosScene.reducer';
import * as fromSceneShare from './reducers/AdmMapa/Escenarios/ShareScene.reducer';
import * as fromDUE from './reducers/AdmMapa/Escenarios/EliminarUE.reducer';
import * as fromAddScene from './reducers/AdmMapa/Escenarios/AddScene.reducer';
import * as fromDelScene from './reducers/AdmMapa/Escenarios/EliminarScene.reducer';
import * as fromTool from './reducers/AdmMapa/Eventos/ToolVisible.reducers';
import * as fromPDN from './reducers/AdmMapa/DatosNISOUC/PanelNISOUC.reducers';
import * as fromEditO from './reducers/AdmMapa/Eventos/ActiveEditor.reducers';
import * as fromPrintM from './reducers/Componentes/panelPrintMap.reducers';

export interface AppState {
    auth: fromAuth.AuthState;
    forgot: fromForgot.ForgotState;
    perfilInic: fromPerfilInic.PefilIniState;
    mapaBase: fromMapaBase.MapaBaseState;
    listaLayers: fromListaLayers.ListaLayersState;
    modelosEjecutados: fromModelosEjecutados.ModelosEjecutadosState;
    redAgua: fromRedAgua.RedAguaState;
    busquedaNiss: fromBusquedaNiss.BusquedaNissState;
    rangoMP: fromRangoMP.rangosMPState;
    menu: fromMenuAction.menuState;
    panelD: fromPDAction.PDState;
    fichaPD: fromFichaPDAction.FichaPDState;
    opcionDC: fromOpcionDCAction.OpcionDCState;
    opcionDM: fromOpcionDMAction.OpcionDMState;
    panelMBase: fromPMBaseAction.PMBaseState;
    panelCtool: fromPCToolsAction.PCtoolsState;
    panelDMS: fromdatosMPSAction.MPState;
    graficoS: fromGraficoSAction.GraficoSState;
    panelOL: fromPOLAction.POLState;
    resultAR: fromResultAR.ResultARState;
    color: fromColor.ColorState;
    panelEL: fromPELAction.PELState;
    panelEOUC: fromPEOUCAction.PEOUDState;
    panelSGL: fromSGLAction.SGLState;
    operCarto: fromOperCato.OperCapasState;
    datosCA: fromDCA.DCAState;
    opcionDS: fromODS.OpcionDSState;
    opcionES: fromOES.OpcionESState;
    rRegUsr: fromRegUsr.RegUserState;
    AdmCarto: fromAdmCarto.AdmCartoState;
    AdmGrpCarto: fromAdmGrpCarto.AdmGrpCartoState;
    AdmModelos: fromAdmModelos.AdmModeloState;
    AdmGrpModelos: fromAdmGrpModelos.AdmGrpModeloState;
    AdmDatosT: fromAdmDatosT.AdmDatosTState;
    AdmCamposC: fromAdmCamposC.AdmCamposCState;
    MainLoad: fromMainLoad.LoadState;
    AdmPerfil: fromPerfiles.AdmPerfilState;
    AdmUsuario: fromUsuarios.AdmUsersState;
    AdmEmpresa: fromEmpresa.AdmEmpresaState;
    selectCP: fromSelectCP.SelectViewState;
    OCatalogo: fromCatalogos.CatalogoState;
    ConfScene: fromCScene.ConfSceneState;
    Scene: fromScene.SceneState;
    UserScene: fromUserScene.UsersSceneState;
    ShareScene: fromSceneShare.SceneShareState;
    DUScene: fromDUE.DUEState;
    AddScene: fromAddScene.AddSceneState;
    DelScene: fromDelScene.DSceneState;
    ToolV: fromTool.ToolState;
    PanelDNis: fromPDN.PDNistate;
    EditorOp: fromEditO.EditState;
    PrintMapS: fromPrintM.PrintMState;
}


export const appReducers: ActionReducerMap<AppState> = {
    auth: fromAuth.authReducer,
    forgot: fromForgot.forgotReducer,
    perfilInic: fromPerfilInic.perfilInicReducer,
    mapaBase: fromMapaBase.mapaBaseReducer,
    listaLayers: fromListaLayers.ListaLayersReducer,
    modelosEjecutados: fromModelosEjecutados.ModelosEjecutadosReducer,
    redAgua: fromRedAgua.redAguaReducer,
    busquedaNiss: fromBusquedaNiss.BusquedaNissReducer,
    rangoMP: fromRangoMP.rangosMPReducer,
    menu: fromMenuAction.menuReducer,
    panelD: fromPDAction.pdReducer,
    fichaPD: fromFichaPDAction.fichaPDReducer,
    opcionDC: fromOpcionDCAction.opcionDCReducer,
    opcionDM: fromOpcionDMAction.opcionDMReducer,
    panelMBase: fromPMBaseAction.pMbaseReducer,
    panelCtool: fromPCToolsAction.pCtoolsReducer,
    panelDMS: fromdatosMPSAction.mPSReducer,
    graficoS: fromGraficoSAction.graficoSReducer,
    panelOL: fromPOLAction.polReducer,
    resultAR: fromResultAR.resultARReducer,
    color: fromColor.colorReducer,
    panelEL: fromPELAction.pelReducer,
    panelEOUC: fromPEOUCAction.PEOUCReducer,
    panelSGL: fromSGLAction.sglReducer,
    operCarto: fromOperCato.operCartoReducer,
    datosCA: fromDCA.DCAReducer,
    opcionDS: fromODS.opcionDSReducer,
    opcionES: fromOES.opcionESReducer,
    rRegUsr: fromRegUsr.RegUsrReducer,
    AdmCarto: fromAdmCarto.admCartoReducer,
    AdmGrpCarto: fromAdmGrpCarto.admGrpCartoReducer,
    AdmModelos: fromAdmModelos.admModelosReducer,
    AdmGrpModelos: fromAdmGrpModelos.admGrpModelosReducer,
    AdmDatosT: fromAdmDatosT.admDatosTReducer,
    AdmCamposC: fromAdmCamposC.admCamposCReducer,
    MainLoad: fromMainLoad.loadReducer,
    AdmPerfil: fromPerfiles.admPerfilReducer,
    AdmUsuario: fromUsuarios.admUsersReducer,
    AdmEmpresa: fromEmpresa.admEmpresaReducer,
    selectCP: fromSelectCP.selectViewReducer,
    OCatalogo: fromCatalogos.CatalogoReducer,
    ConfScene: fromCScene.confSceneReducer,
    Scene: fromScene.sceneReducer,
    UserScene: fromUserScene.userSceneReducer,
    ShareScene: fromSceneShare.sceneShareReducer,
    DUScene: fromDUE.DUEReducer,
    AddScene: fromAddScene.AddSceneReducer,
    DelScene: fromDelScene.dSceneReducer,
    ToolV: fromTool.ToolVReducer,
    PanelDNis: fromPDN.PDNisReducer,
    EditorOp: fromEditO.EditorReducer,
    PrintMapS: fromPrintM.PrintMReducer
};

